<template>
  <div class="common-table">
    <div class="top">
      <div class="title">
        <div style="display:flex;margin-right:14px">
          <div class="bot"></div>
          <div style="margin-left:10px">失连</div>
        </div>
        <div style="display:flex;margin-right:14px">
          <div class="bot red"></div>
          <div style="margin-left:10px">离线</div>
        </div>
        <div style="display:flex;margin-right:14px">
          <div class="bot green"></div>
          <div style="margin-left:10px">在线</div>
        </div>
      </div>
    </div>
    <el-table :data="tableData" style="width: 100%" height="780">
      <el-table-column label="表计名称" prop="name"> </el-table-column>
      <el-table-column label="在线状态" prop="onLineStatus">
        <template slot-scope="scope">
          <div style="display:flex" v-if="scope.row.onLineStatus == '-1'">
            <div class="bot"></div>
            <div style="margin-left:10px">失连</div>
          </div>
          <div style="display:flex" v-else-if="scope.row.onLineStatus == '1'">
            <div class="bot green"></div>
            <div style="margin-left:10px">在线</div>
          </div>

          <div style="display:flex" v-else>
            <div class="bot red"></div>
            <div style="margin-left:10px">离线</div>
          </div>
        </template>
      </el-table-column>
      <el-table-column label="活动状态" prop="onActiveStatus">
        <template slot-scope="scope">
          <div style="display:flex" v-if="scope.row.onActiveStatus == '-1'">
            <div class="bot"></div>
            <div style="margin-left:10px">失连</div>
          </div>
          <div style="display:flex" v-else-if="scope.row.onActiveStatus == '1'">
            <div class="bot green"></div>
            <div style="margin-left:10px">活跃</div>
          </div>
          <div style="display:flex" v-else>
            <div class="bot red"></div>
            <div style="margin-left:10px">不活跃</div>
          </div>
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
import api from "@common/api/index.js";
import socket from "@/utils/websocket.js"; // 组件
import { findDataByParam } from "@/utils/index.js";
export default {
  data () {
    return {
      viewId: 0,
      tableData: [],
      expression: {},
      webSock: {},
      socket: null,
      wsdata: [
        {
          data: [
            {
              pointCode: 601,
              pointNumber: 10001,
              value: 0
            }
          ],
          measureId: "3301623012764917800",
          time: "2021-05-19 15:22:40.000"
        }
      ]
    };
  },
  created () {
    this.getMyFrontEndPageCustomParam();
  },
  methods: {
    allotMeasuringRealtimeNotifyServer () {
      let vm = this;
      api.measuringServer.allotMeasuringRealtimeNotifyServer().then(res => {
        vm.webSock.ip = res.data.ip;
        vm.webSock.port = res.data.port;
        vm.webSock.key = res.data.key;
        vm.webSock.path = res.data.path;
        vm.initWebSock();
      });
    },
    initWebSock () {
      let vm = this;
      let agentData = {
        methodCode: "101",
        key: vm.webSock.key
      };
      if (vm.socket) {
        vm.socket.close();
        vm.socket = null;
      }
      vm.socket = new socket({
        //网址（端口是我下面的服务器的端口）
        url:
          window.baseConfig.wsAgreement + "://" +
          vm.webSock.ip +
          ":" +
          vm.webSock.port +
          "/" +
          vm.webSock.path
      });

      vm.socket.onopen(event => {
        vm.socket.send(agentData);
      });
      //接收信息
      vm.socket.onmessage(data => {
        vm.webSockMsg(JSON.parse(data));
      });
    },
    webSockMsg (e) {
      let vm = this;
      if (e.methodCode == "102") {
        //注册计量点  103
        let measures = [];
        for (let i = 0; i < vm.tableData.length; i++) {
          const element = vm.tableData[i];
          measures.push({
            id: element.id,
            points: [
              { code: 601, number: 10001 },
              { code: 601, number: 10002 }
            ]
          });
        }
        let agentData = {
          methodCode: "103",
          measures: measures
        };
        vm.socket.send(agentData);
      } else if (e.methodCode === "105") {
        for (let i = 0; i < e.data.length; i++) {
          const measureItem = e.data[i];
          const index = vm.tableData.findIndex(
            c => c.id === measureItem.measureId
          );
          for (let j = 0; j < measureItem.data.length; j++) {
            // 数据项数据data
            const dataItem = measureItem.data[j];
            if (dataItem.pointCode === 601 && dataItem.pointNumber === 10001) {
              vm.tableData[index].onLineStatus = dataItem.value;
            } else if (
              dataItem.pointCode === 601 &&
              dataItem.pointNumber === 10002
            ) {
              vm.tableData[index].onActiveStatus = dataItem.value;
            }
          }
        }
      }
    },
    getMyFrontEndPageCustomParam () {
      let vm = this;
      vm.$api.frontEndPageCustomParam.getMyFrontEndPageCustomParam(
        this.$store.state.currentCompanyId,
        "/v2.0/communicationTable/communicationTable",
        null
      )
        .then(res => {
          if (res.success) {
            // vm.viewId = res.data[0].value;
            const viewId = findDataByParam("viewId", false, res.data);
            vm.viewId = viewId;
            this.getViewTreeNodes(vm.viewId);
          }
        });
    },
    getViewTreeNodes (id) {
      let vm = this;
      api.view.getViewTreeNodes(id).then(res => {
        if (res.success) {
          let tableData = [];
          for (let i = 0; i < res.data.length; i++) {
            const element = res.data[i];
            tableData.push({
              id: element.measureId,
              name: element.measureName,
              onLineStatus: -1,
              onActiveStatus: -1
            });
          }
          this.tableData = tableData;
          this.allotMeasuringRealtimeNotifyServer();
        }
      });
    }
  },
  mounted () { }
};
</script>

<style lang="scss" scoped>
.common-table {
  padding: 14px;
}
.bot {
  width: 20px;
  height: 20px;
  border-radius: 50%;
  background: #eee;
}
.red {
  background: #e62e4d;
}
.green {
  background: #52cca3;
}
::v-deep .el-table .has-gutter tr .el-table_1_column_1 {
  background-color: #f0f3f4;
  color: #2a2b2c;
}
::v-deep .el-table .has-gutter tr .el-table_1_column_2 {
  background-color: #f0f3f4;
  color: #2a2b2c;
}
::v-deep .el-table .has-gutter tr .el-table_1_column_3 {
  background-color: #f0f3f4;
  color: #2a2b2c;
}
.top {
  margin-bottom: 14px;
}
.title {
  padding: 14px;
  border-bottom: 1px solid #ccc;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  color: #000;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  background: #fff;
}
</style>
